export default {
  title: {
    id: 'product_page_express_replacement_title',
    defaultMessage: 'Express Replacement included',
  },
  subtitle: {
    id: 'product_page_express_replacement_subtitle',
    defaultMessage: 'Not a day without a device',
  },
}
